/*
 * Created by: cparaschiv
 * Date: 26.03.2013, 10:56
 */

(function () {
	'use strict';

	// represents the max no of toasts displayed after which when a new toast 
	// is addded the oldest toast is removed
	var noOfToastsDisplayed = 3;
	var toasts = {};
	var addToast = function (type, toast) {
		if (noOfToastsDisplayed <= 0)
			return;

		var available = toasts[type] || (toasts[type] = []);

		available.push(toast);

		while (available.length > noOfToastsDisplayed) {
			toastr.clear(available[0]);
			available.splice(0, 1);
		}
	};

	var removeToast = function (type, toast) {
		if (noOfToastsDisplayed <= 0)
			return;

		var available = toasts[type] || (toasts[type] = []);

		for (var i = available.length - 1; i >= 0; i--) {
			if (available[i] === toast) {
				available.splice(i, 1);
			}
		}
	};

	/** @module TS.Notify */
	TS.Notify = TS.Notify || {};



	$.extend(TS.Notify,
    /** @exports TS.Notify*/
    {

    	/**
         * Clears all notifications.
         * @static
         */
    	clear: function () {
    		toastr.clear();
    	},

    	fastClear: function () {
    		toastr.getContainer().remove();
    	},

    	/**
         * Displays a warning notification.
         * @param message {String}
         * @param title {String}
         * @param opts {Object} Further options to be passed to toastr
         * @static
         */
    	warning: function (message, title, opts) {
    		toastr.warning(message, title, opts);
    	},

    	/**
         * Displays a success notification.
         * @param message {String}
         * @param title {String}
         * @param opts {Object} Further options to be passed to toastr
         * @static
         */
    	success: function (message, title, opts) {
    		toastr.success(message, title, opts);
    	},

    	/**
         * Displays an error notification.
         * @param message {String}
         * @param title {String}
         * @param opts {Object} Further options to be passed to toastr
         * @static
         */
    	error: function (message, title, opts) {
    		var toast = toastr.error(message, title, $.extend(opts, {
    			timeOut: 0,
    			complete: function () { removeToast('error', toast); }
    		}));
    		addToast('error', toast);
    	},

    	/**
         * Displays an information notification.
         * @param message {String}
         * @param title {String}
         * @param opts {Object} Further options to be passed to toastr
         * @static
         */
    	info: function (message, title, opts) {
    		toastr.info(message, title, opts);
    	}
    });

})();